module.exports = __webpack_public_path__ + "img/620.492de579.jpg";